var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "register-container" }, [
      _vm.isSuccess
        ? _c("div", [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "announce-container" }, [
              _c("span", [_vm._v("サービス登録が完了しました。")]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("span", [_vm._v("ログイン情報は、メールにお送りしました。")]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("span", [_vm._v("以下よりログインしてください。")]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-info btn-block",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.toLogin($event)
                    }
                  }
                },
                [_vm._v("ログイン")]
              )
            ])
          ])
        : _vm.isExpired || _vm.error
        ? _c("div", [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "announce-container" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-info btn-block",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.toSignup($event)
                    }
                  }
                },
                [_vm._v("新規登録")]
              )
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("h1", [_vm._v("サービス登録完了")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("h1", [_vm._v("このURLは利用出来ません ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "text-red" }, [
      _vm._v("メール本文に記載されたURLと異なるURLを指定している "),
      _c("br"),
      _vm._v("\n        （メールソフトによりURLが改行されている等）か、"),
      _c("br"),
      _vm._v(
        "\n          URLの有効期限が切れている可能性があります。\n        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("\n          有効期限切れの場合は以下より"),
      _c("br"),
      _vm._v("\n          再度登録を行ってください。\n        ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-315d4f95", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-315d4f95","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/signup/SignupSuccess.vue
// module id = null
// module chunks = 